import {
    fetchAlertHistoryList,
    setCategoryId,
    setSearchValue,
    setSelectedDateTimestamp,
    setPage,
} from '../alertHistory';
import { getParamsFromState } from '../utils';
import { IDS } from 'services/alertHistory/constants';
import { buildListOfHistoryEvents, getAlertHistoryList } from 'services/alertHistory';
import { bugsnagNotifyWrapper } from 'containers/ErrorBoundary/utils';

jest.mock('services/alertHistory', () => ({
    buildListOfHistoryEvents: jest.fn(),
    getAlertHistoryList: jest.fn(),
}));
jest.mock('../utils', () => ({
    getParamsFromState: jest.fn(),
    getStartOfCurrentDayTimestamp: jest.fn(),
}));
jest.mock('containers/ErrorBoundary/utils', () => ({
    bugsnagNotifyWrapper: jest.fn(),
}));
describe('fetchAlertHistoryList', () => {
    beforeEach(() => {
        jest.clearAllMocks(); // Reset mock calls before each test
    });

    it('fetchAlertHistoryList is called with correct parameters and dispatches actions', async () => {
        // Mock getState and dispatch functions
        const getState = jest.fn();
        const dispatch = jest.fn();

        // Mock payload
        const payload = { pageNumber: 1, pageType: 'next' };

        // Mock return values for getParamsFromState
        getParamsFromState.mockReturnValueOnce({ page: 1 });

        // Mock return value for getAlertHistoryList
        const historyEventsRange = [{ id: 1, name: 'Event 1' }];
        getAlertHistoryList.mockResolvedValueOnce(historyEventsRange);

        // Call the function
        await fetchAlertHistoryList(payload)(dispatch, getState);

        // Assertions
        expect(getParamsFromState).toHaveBeenCalledWith(getState(), payload);
        expect(getAlertHistoryList).toHaveBeenCalledWith({ page: 1 });
        expect(dispatch).toHaveBeenCalledWith({ type: 'alert/history/setPage', payload: 1 });
        expect(buildListOfHistoryEvents).toHaveBeenCalledWith(historyEventsRange);
    });
    it('fetchAlertHistoryList is called with error', async () => {
        // Mock getState and dispatch functions
        const getState = jest.fn();
        const dispatch = jest.fn();
        const error = new Error('Error fetching alert history list');

        const payload = { pageNumber: 1, pageType: 'next' };
        getParamsFromState.mockReturnValueOnce({ page: 1 });
        getAlertHistoryList.mockRejectedValueOnce(error);

        // Call the function
        await fetchAlertHistoryList(payload)(dispatch, getState);
        await expect(dispatch).toBeCalledWith(expect.objectContaining({ type: 'alert/history/fetchList/pending' }));
        await expect(bugsnagNotifyWrapper).toBeCalledWith(error, {
            params: { page: 1 },
            thunkCall: 'alert/history/fetchList',
        });
        await expect(dispatch).toBeCalledWith(expect.objectContaining({ type: 'alert/history/fetchList/rejected' }));
    });
});

describe('setCategoryId', () => {
    it('creates the correct action', () => {
        const action = setCategoryId(IDS.SYSTEM);
        expect(action).toEqual({ type: 'alert/history/setCategoryId', payload: IDS.SYSTEM });
    });
});

describe('setSearchValue', () => {
    it('creates the correct action', () => {
        const action = setSearchValue('search value');
        expect(action).toEqual({ type: 'alert/history/setSearchValue', payload: 'search value' });
    });
});

describe('setSelectedDateTimestamp', () => {
    it('creates the correct action', () => {
        const action = setSelectedDateTimestamp(1234567890);
        expect(action).toEqual({ type: 'alert/history/setSelectedDateTimestamp', payload: 1234567890 });
    });
});

describe('setPage', () => {
    it('creates the correct action', () => {
        const action = setPage(1);
        expect(action).toEqual({ type: 'alert/history/setPage', payload: 1 });
    });
});
